import Icon from '@/atoms/Icon/Icon';
import {StyledAboutLinks, StyledAccordion, StyledBody, StyledLink, StyledTitle} from './styles';
import {AboutLinksArtistPageProps, SocialLinkProps} from './typings';
export const socialMap = {
  facebook: {
    msg: 'Like me on Facebook',
    icon: 'facebook',
  },
  instagram: {
    msg: 'Follow me on Instagram',
    icon: 'instagram',
  },
  pinterest: {
    msg: 'Follow me on Pinterest',
    icon: 'pinterest',
  },
  twitter: {
    msg: 'Follow me on X',
    icon: 'twitter',
  },
};

const Links = ({website, socialLinks}: AboutLinksArtistPageProps): JSX.Element => {
  return (
    <>
      {!!socialLinks?.length && (
        <>
          {socialLinks.map((socialLink: SocialLinkProps) => {
            const mapKey = socialLink.platform.toLowerCase();
            return socialMap[mapKey] ? (
              <StyledLink key={`social-link-${mapKey}`} href={socialLink.url} rel="nofollow">
                <Icon type={socialMap[mapKey].icon} />

                {socialMap[mapKey].msg}
              </StyledLink>
            ) : null;
          })}
        </>
      )}

      {website && (
        <StyledLink href={website} rel="nofollow">
          <Icon type="link" />
          Visit my website
        </StyledLink>
      )}
    </>
  );
};

const AboutLinksArtistPage = ({
  website,
  socialLinks,
  className,
}: AboutLinksArtistPageProps): JSX.Element | null => {
  const title = 'Links';

  return website || socialLinks?.length ? (
    <>
      <StyledAboutLinks className={className}>
        <StyledTitle>{title}</StyledTitle>

        <StyledBody>
          <Links website={website} socialLinks={socialLinks} />
        </StyledBody>
      </StyledAboutLinks>

      <StyledAccordion title={title} strongTitle={false} className={className}>
        <Links website={website} socialLinks={socialLinks} />
      </StyledAccordion>
    </>
  ) : null;
};

export default AboutLinksArtistPage;
